import {Dispatch} from "redux";

import {RequestState} from "@pg-mono/request-state";

import {IRootState} from "../../store/store";
import {selectGetIsUserAuthenticated} from "../../user/utils/select_get_is_user_authenticated";
import {loadFavouritesToStore} from "./load_favourites_to_store";
import {loadLocalStorageFavouritesToStore} from "./load_local_storage_favourites_to_store";

export const initializeAppStoreFavourites = () => async (dispatch: Dispatch, getState: () => IRootState) => {
    const state = getState();
    const isAuthenticated = selectGetIsUserAuthenticated(state);
    const fetchRequest = state.favourite.fetchRequest;

    if (!isAuthenticated) {
        return dispatch(loadLocalStorageFavouritesToStore());
    }

    if (fetchRequest !== RequestState.Success) {
        dispatch(loadFavouritesToStore());
    }

    return;
};
import {Dispatch} from "redux";

import {RequestState} from "@pg-mono/request-state";

import {IRootState} from "../../store/store";
import {selectGetIsUserAuthenticated} from "../../user/utils/select_get_is_user_authenticated";
import {loadFavouritesToStore} from "./load_favourites_to_store";
import {loadLocalStorageFavouritesToStore} from "./load_local_storage_favourites_to_store";

export const initializeAppStoreFavourites = () => async (dispatch: Dispatch, getState: () => IRootState) => {
    const state = getState();
    const isAuthenticated = selectGetIsUserAuthenticated(state);
    const fetchRequest = state.favourite.fetchRequest;

    if (!isAuthenticated) {
        return dispatch(loadLocalStorageFavouritesToStore());
    }

    if (fetchRequest !== RequestState.Success) {
        dispatch(loadFavouritesToStore());
    }

    return;
};
